import React, { Component } from 'react';

import brazilseedsLogo from './assets/brazilseedslogogrande.png';
import indexLogos from './assets/index-logos.png';


class StartPage extends Component {
  render() {
    return(    
        <div id="body">
          <img src={indexLogos} id="body-logo"/>

          <h1 id="body-h1"> A Semente da integração</h1>
        </div>
    );
  }
}

export default StartPage;



// WEBPACK FOOTER //
// ./src/StartPage.js